import { render, staticRenderFns } from "./NewArticles.vue?vue&type=template&id=09a5dd3b&scoped=true"
import script from "./NewArticles.vue?vue&type=script&lang=js"
export * from "./NewArticles.vue?vue&type=script&lang=js"
import style0 from "./NewArticles.vue?vue&type=style&index=0&id=09a5dd3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a5dd3b",
  null
  
)

export default component.exports